// extracted by mini-css-extract-plugin
export default {"policyPetsStatusValue":"RemovedPetsList_policyPetsStatusValue__iVSUU","policyPetsStatusValueList":"RemovedPetsList_policyPetsStatusValueList__wGMK8"};